import Tr from "translations/Translations";

export const RegistrationStatus = {
    NEW: "NEW",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
}
const _TR_PREFIX = 'registration_status_';

export const RegistrationStatusLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));